module.exports = __webpack_public_path__ + "img/icon-Link.e3d62fde.svg";